import { render, staticRenderFns } from "./SpaceMenu.vue?vue&type=template&id=9a9580dc&"
import script from "./SpaceMenu.vue?vue&type=script&lang=js&"
export * from "./SpaceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports